$(document).ready(function () {
    var get_ajax = window.location.origin + "/ajax/auto";
    var img_path =  window.location.origin + "/uploads/products_icon";

    var engine = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        prefetch: get_ajax,
        remote: {
            url: get_ajax + '?query=%QUERY',
            wildcard: '%QUERY'
        }
    });

    $('.typeahead-spinner').hide();

    $('.typeahead-input').typeahead({
        hint: $('.typeahead-hint'),
        highlight: true,
        minLength: 2,
        classNames: {
            open: 'is-open',
            empty: 'is-empty',
            cursor: 'is-active',
            suggestion: 'typeahead-suggestion',
            selectable: 'typeahead-selectable'
        }
    }, {
        name: 'best-products',
        source: engine.ttAdapter(),
        display: 'name',
        templates: {
            // empty: [
            //     '<div class="empty-message alert alert-info mb-0">',
            //     'Unable to find any Products that match the query!',
            //     '</div>'
            // ].join('\n'),
            suggestion:
                function (data) {
                    html  = '<div class="media product_card">';
                    html += '<img src="' + img_path + '/' + data.product_image.name+'" class="mr-2 img-thumbnail" width="50;">';
                    html += '<div class="media-body">';
                    html += '<p class="m-0">' + data.name + '</p>';
                    html += 'Nu. '+data.p_rate+'';
                    html += '</div>';
                    html += '</div>';
                    return html;
                }
            // Handlebars.compile('<div><strong>name</strong></div>'+name)
        }
    }).bind('typeahead:selected', function (obj, datum) {
        window.location.href = window.location.origin + "/product/" + datum.slug;
    }).on('typeahead:asyncrequest', function() {
        $('.typeahead-spinner').show();
    }).on('typeahead:asynccancel typeahead:asyncreceive', function() {
        $('.typeahead-spinner').hide();
    });
});
